import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { handlesOwnErrors } from '@core/authentication';

export interface LoginSettings {
  clubName: string;
  clubLogo: string;
  /** Contact for "Zugang einrichten"; `null` hides the link (login spec 5). */
  webmaster: { name: string; email: string } | null;
  imprintUrl: string | null;
  privacyUrl: string | null;
  resetLinkMinutes: number;
  lockoutMinutes: number;
}

const DEFAULTS: LoginSettings = {
  clubName: 'Club Manager',
  clubLogo: '',
  webmaster: null,
  imprintUrl: null,
  privacyUrl: null,
  resetLinkMinutes: 30,
  lockoutMinutes: 15,
};

/** Club data of the login pages (`GET /public/v2/login-settings`), loaded once. */
@Injectable({ providedIn: 'root' })
export class LoginSettingsService {
  private readonly http = inject(HttpClient);
  private readonly api = inject<string>('API_URL' as any);

  readonly settings$: Observable<LoginSettings> = this.http
    .get<Partial<LoginSettings>>(`${this.api}/public/v2/login-settings`, { context: handlesOwnErrors() })
    .pipe(
      map(settings => ({ ...DEFAULTS, ...settings, clubName: settings.clubName || DEFAULTS.clubName })),
      // Without the settings the login still works, with the defaults.
      catchError(() => of(DEFAULTS)),
      shareReplay(1)
    );
}
